module.exports = __webpack_public_path__ + "img/alcool.fb7d6ea7.svg";